module.exports = __webpack_public_path__ + "img/1.729d6116.png";